import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StateManagerService {

  constructor() {
  }

  hasLetter(letter): boolean {
    return localStorage.getItem('letter_' + letter) !== null;
  }

  awardLetter(letter): void {
    console.log('set letter', letter);
    localStorage.setItem('letter_' + letter, letter);
  }

}
